import React from "react";

const CmoSummitEventSection = () => {
  return (
    <div className="column-sections pb-20">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="column-content">
            <div class="service_style_two_title pb-3 text-left">
                  <h4>The Real GTM Challenge: Timing, Not Data</h4>
            </div>
              <p className="text-left black">Across conversations at the event, one insight stood out : B2B organizations don’t lack data; they lack decisive timing.</p>
              <p className="text-left black">Marketing and sales teams are still:</p>
              <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6> reacting to fragmented intent signals</h6>
              </div>
            </div>
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>executing campaigns without a real buyer context</h6>
              </div>
            </div>
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>struggling to convert the pipeline consistently</h6>
              </div>
            </div>
              

             <div class="service_style_two_title pb-3 text-left">
                  <h4>How ProPlus Data is Solving This</h4>
            </div>
            <p className="text-left">At the summit, ProPlus Data showcased Nexora, a GTM AI platform designed to bring timing clarity into pipeline decisions.</p>
            <p className="text-left">Nexora enables teams to:</p>
              <div class="col-md-12 col-lg-6 text-left">
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Identify in-market accounts using intent data</h6>
              </div>
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Predict what buyers are likely to purchase next</h6>
              </div>
            </div>
            <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Engage at the right moment to improve conversion rates</h6>
              </div>
            </div>
            <p>This shifts GTM execution from volume-driven to precision-driven.</p>
             
           
            {/* <div class="service_style_two_title pt-4 text-left">
                  <h6 className="w-100">One solution that sparked major interest: Next Tech Purchase®, our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:
                  </h6>
            </div>   */}
          
          </div>
            {/* <p className="text-left">One solution that sparked major interest: <a href="https://proplusdata.co/next-tech-purchase">Next Tech Purchase®</a> , our proprietary predictive engine that forecasts upcoming technology investments before traditional intent data can. For marketing teams, it means one thing:</p>
            <p className="text-left">A first-mover advantage on tech-buying accounts that are still off your radar.</p> */}
          <div class="service_style_two_title pt-4 text-left">
                  <h4>From Intent Data to Predictable Pipeline</h4>
            </div>
          <p className="text-left">The future of B2B marketing isn’t about more data sources. It’s about: </p>
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>interpreting buying signals accurately</h6>
              </div>
            </div>
             <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>acting at the right time</h6>
              </div>
            </div>
             <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>driving consistent pipeline outcomes</h6>
              </div>
            </div>
            
          <div class="service_style_two_title pt-4 text-left">
                  <h4>The Takeaway</h4>
            </div>
          <p className="text-left">ProPlus Data’s presence at the CMO Leadership Summit 2026 reinforced a critical shift in B2B GTM strategy:</p>
          <p className="text-left">Predictable pipeline is built on timing, not just data.

</p>

          

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CmoSummitEventSection;
